import React from "react";
type SectionHeadingProps = {
  id: string;
  eyebrow: string;
  title: string;
  intro?: string;
  tone?: "light" | "dark";
};
export function SectionHeading({
  id,
  eyebrow,
  title,
  intro,
  tone = "light"
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  return <div className="max-w-3xl" data-id="element-265" data-mp="y6zp3jan111f">
      <p className={`text-sm font-bold ${isDark ? "text-redLight" : "text-rinnai"}`} data-id="element-266" data-mp="y8139wmya3nd">{eyebrow}</p>
      <h2 id={id} className="mt-4 text-3xl font-bold tracking-[-0.04em] sm:text-4xl lg:text-5xl" data-id="element-267" data-mp="aigir9b5eybz">{title}</h2>
      {intro && <p className={`mt-5 text-lg leading-8 ${isDark ? "text-white/85" : "text-muted"}`} data-id="element-268" data-mp="5jvhd6k5u8ly">{intro}</p>}
    </div>;
}